import { SupplierTypeEnum } from '@gtpl/shared-models/common-models';
import { SupplierDTO } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { Countries } from '../../countries/countries.entity';
import { Currencies } from '../../currencies/currencies.entity';
import { Farm } from '../farms.entity';
import { Supplier } from '../supplier.entity';
import { FarmsInfo } from './farms.model';
import { SuppliersDTO } from './suppliers.dto';
// import { Vendors } from '../vendors.entity';
// import { supplierDto } from './vendors.dto';

@Injectable()
export class SuppliersAdapter {
  /**
   * 
   * @param supplierDto 
   * @param isUpdate 
   * @returns 
   */
  public convertDtoToEntity(supplierDto: SupplierDTO, isUpdate: boolean = false): Supplier {
    const suppliers = new Supplier();
    suppliers.supplierId = supplierDto.supplierId;
    suppliers.supplierCode = supplierDto.supplierCode;
    suppliers.supplierName = supplierDto.supplierName;
    suppliers.aadharNumber = supplierDto.aadharNumber;
    suppliers.gstNumber = supplierDto.gstNumber;
    suppliers.contactPerson = supplierDto.contactPerson;
    suppliers.supplierCategory = supplierDto.supplierCategory;
    // if(supplierDto.supplierCategory == SupplierTypeEnum.DEALER){
    //   for(const farmer of supplierDto.Farmers){
    //     suppliers.supplierId=farmer.farmerId;
    //     suppliers.brokerId=supplierDto.supplierId;
    //   }
    // }
    suppliers.street = supplierDto.street;
    suppliers.state = supplierDto.state;
    suppliers.district = supplierDto.district;
    suppliers.city = supplierDto.city;
    suppliers.apartment = supplierDto.apartment;
    suppliers.postalCode = supplierDto.postalCode;
    suppliers.bankAccNo = supplierDto.bankAccNo;
    suppliers.bankIfsc = supplierDto.bankIfsc;
    suppliers.bankName = supplierDto.bankName;
    suppliers.commission = supplierDto.commission;
    suppliers.bankBranch = supplierDto.bankBranch;
    suppliers.contactNumber = supplierDto.contactNumber;
    suppliers.emailId = supplierDto.emailId;
    suppliers.paymentPeriod = supplierDto.paymentPeriod;
    suppliers.panNumber = supplierDto.panNumber
    suppliers.isActive = supplierDto.isActive == undefined ? true : supplierDto.isActive;
    const farmItems: Farm[] = [];
    if (supplierDto.supplierCategory == SupplierTypeEnum.FARMER) {
      if (supplierDto.farmInfo) {
        for (const farmItem of supplierDto.farmInfo) {
          const farmObj: Farm = new Farm();
          if (farmItem.farmId) {
            farmObj.farmId = farmItem.farmId;
            farmObj.updatedUser = farmItem.createdUser;
          }

          farmObj.farmId = farmItem.farmId;
          farmObj.farmCode = farmItem.farmCode;
          farmObj.farmName = farmItem.farmName;
          farmObj.address = farmItem.address;
          farmObj.NumberOfAcres = farmItem.NumberOfAcres;
          farmObj.numberOfPonds = farmItem.numberOfPonds;
          farmObj.traceCode = farmItem.traceCode;
          farmObj.certificationId = farmItem.certificationId;
          // farmObj.certificationCode = farmItem.certificationCode;
          farmObj.expiryDate =new Date(farmItem.expiryDate);
          farmObj.mobileNumber = farmItem.mobileNumber;
          farmObj.isActive = farmItem.isActive ? farmItem.isActive : true;
          farmObj.createdUser = farmItem.createdUser;

          farmItems.push(farmObj);
        }
      }

    }

    if (isUpdate) {
      suppliers.updatedUser = supplierDto.updatedUser;
    } else {
      suppliers.isActive = true;
      suppliers.createdUser = supplierDto.createdUser;
    }
    suppliers.farmInfo = farmItems;
    return suppliers;
  }
  public convertEntityToDto(supplierObj: Supplier): SuppliersDTO {
    const supplierDto = new SuppliersDTO;
    supplierDto.supplierId = supplierObj.supplierId;
    supplierDto.supplierCode = supplierObj.supplierCode;
    supplierDto.aadharNumber = supplierObj.aadharNumber;
    supplierDto.supplierName = supplierObj.supplierName;
    supplierDto.gstNumber = supplierObj.gstNumber;
    supplierDto.supplierCategory = supplierObj.supplierCategory;
    supplierDto.brokerId = supplierObj.brokerId;
    supplierDto.contactPerson = supplierObj.contactPerson;
    supplierDto.street = supplierObj.street;
    supplierDto.apartment = supplierObj.apartment;
    supplierDto.city = supplierObj.city;
    supplierDto.state = supplierObj.state;
    supplierDto.district = supplierObj.district;
    supplierDto.commission = supplierObj.commission;
    supplierDto.postalCode = supplierObj.postalCode;
    supplierDto.bankAccNo = supplierObj.bankAccNo;
    supplierDto.bankIfsc = supplierObj.bankIfsc;
    supplierDto.bankName = supplierObj.bankName;
    supplierDto.bankBranch = supplierObj.bankBranch;
    supplierDto.contactNumber = supplierObj.contactNumber;
    supplierDto.emailId = supplierObj.emailId;
    supplierDto.paymentPeriod = supplierObj.paymentPeriod;
    supplierDto.isActive = supplierObj.isActive;
    supplierDto.createdUser = supplierObj.createdUser;
    supplierDto.updatedUser = supplierObj.updatedUser;
    supplierDto.updatedUser = supplierObj.updatedUser;
    supplierDto.versionFlag = supplierObj.versionFlag;
    supplierDto.panNumber = supplierDto.panNumber
    const farmDetails : FarmsInfo[] = []
    for(const form of supplierObj.farmInfo){
      const farmDetailsObj = new Farm()
      farmDetailsObj.farmId = form.farmId
      farmDetailsObj.farmCode = form.farmCode;
      farmDetailsObj.farmName = form.farmName;
      farmDetailsObj.NumberOfAcres=form.NumberOfAcres;
      farmDetailsObj.numberOfPonds=form.numberOfPonds;
      farmDetailsObj.traceCode = form.traceCode;
      farmDetailsObj.certificationId = form.certificationId;
      farmDetailsObj.certificationCode = form.certificationCode;
      farmDetailsObj.expiryDate = form.expiryDate;
      farmDetailsObj.mobileNumber = form.mobileNumber;
      farmDetailsObj.isActive = form.isActive;
      farmDetailsObj.createdUser = form.createdUser;
      farmDetailsObj.address = form.address;
      farmDetails.push(farmDetailsObj)
    }
    console.log(farmDetails,'farm')
    supplierDto.farmInfo=farmDetails
    return supplierDto;
  }
}
